"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceUtils = exports.OrderProgressStep = void 0;
var utils_1 = require("../../utils");
var OrderProgressStep;
(function (OrderProgressStep) {
    OrderProgressStep[OrderProgressStep["CreatingAgreement"] = 0] = "CreatingAgreement";
    OrderProgressStep[OrderProgressStep["AgreementInitialized"] = 1] = "AgreementInitialized";
    OrderProgressStep[OrderProgressStep["LockingPayment"] = 2] = "LockingPayment";
    OrderProgressStep[OrderProgressStep["LockedPayment"] = 3] = "LockedPayment";
})(OrderProgressStep = exports.OrderProgressStep || (exports.OrderProgressStep = {}));
var ServiceUtils = (function () {
    function ServiceUtils(ocean, logger) {
        this.ocean = ocean;
        this.logger = logger;
    }
    ServiceUtils.prototype.order = function (type, condition, observer, consumerAccount, ddo, provider) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, keeper, agreements, agreementId, service, metadata, templateName, template, price, paymentFlow, _provider, providers, e_1;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.ocean, keeper = _a.keeper, agreements = _a.agreements;
                        agreementId = utils_1.zeroX(utils_1.generateId());
                        service = ddo.findServiceByType(type);
                        metadata = ddo.findServiceByType('metadata');
                        templateName = service.attributes.serviceAgreementTemplate.contractName;
                        template = keeper.getTemplateByName(templateName);
                        price = type === 'compute'
                            ? service.attributes.main.price
                            : metadata.attributes.main.price;
                        paymentFlow = new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                            var serviceGranted, paid;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4, template.getAgreementCreatedEvent(agreementId).once()];
                                    case 1:
                                        _a.sent();
                                        this.logger.log('Agreement initialized');
                                        observer.next(OrderProgressStep.AgreementInitialized);
                                        this.logger.log('Locking payment');
                                        serviceGranted = condition
                                            .getConditionFulfilledEvent(agreementId)
                                            .once();
                                        observer.next(OrderProgressStep.LockingPayment);
                                        return [4, agreements.conditions.lockReward(agreementId, price, consumerAccount)];
                                    case 2:
                                        paid = _a.sent();
                                        observer.next(OrderProgressStep.LockedPayment);
                                        if (paid) {
                                            this.logger.log('Payment was OK');
                                        }
                                        else {
                                            this.logger.error('Payment was KO');
                                            this.logger.error('Agreement ID: ', agreementId);
                                            this.logger.error('DID: ', ddo.id);
                                            reject(new Error('Error on payment'));
                                        }
                                        return [4, serviceGranted];
                                    case 3:
                                        _a.sent();
                                        this.logger.log("Service " + type + " granted");
                                        resolve();
                                        return [2];
                                }
                            });
                        }); });
                        observer.next(OrderProgressStep.CreatingAgreement);
                        this.logger.log('Creating agreement');
                        _provider = provider;
                        if (!!provider) return [3, 2];
                        return [4, keeper.didRegistry.getDIDProviders(ddo.shortId())];
                    case 1:
                        providers = _b.sent();
                        if (providers) {
                            _provider = providers[0];
                        }
                        _b.label = 2;
                    case 2: return [4, agreements.create(ddo.id, agreementId, service.index, undefined, consumerAccount, _provider, consumerAccount)];
                    case 3:
                        _b.sent();
                        this.logger.log('Agreement created');
                        _b.label = 4;
                    case 4:
                        _b.trys.push([4, 6, , 7]);
                        return [4, paymentFlow];
                    case 5:
                        _b.sent();
                        return [3, 7];
                    case 6:
                        e_1 = _b.sent();
                        throw new Error("Error paying the " + type + " service.");
                    case 7: return [2, agreementId];
                }
            });
        });
    };
    return ServiceUtils;
}());
exports.ServiceUtils = ServiceUtils;
//# sourceMappingURL=ServiceUtils.js.map